import {
  ElectricBoltOutlined,
  LocalShippingOutlined,
} from "@mui/icons-material";
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import SharePopover from "../Sharing/shareComponent";

const MENU_ITEM_CLASS = "asset-card-menu-item";

export const buildContextMenu = ({
  type,
  object,
  objectId,
  name,

  canEdit,
  canDelete,
  canShare,

  contentTypeId,
  contentTypeLoading,

  // Actions
  onInfo,
  onEdit,
  onDelete,
  // Given only when this user may update this asset's logistics progress.
  onUpdateLogistics,

  // Optional components
  DocsComponent,
  AddEnergyComponent,
  ExtraCreateItems = [], // e.g. tiers submenu
  ShareComponent,
}) => {
  const items = [];

  // 🔹 VIEW
  if (DocsComponent) {
    items.push({
      key: "docs",
      label: DocsComponent,
    });
  }

  items.push({
    key: "info",
    label: "Details",
    icon: <InfoCircleOutlined style={{ fontSize: 18, color: "#008d8a" }} />,
    onClick: (e) => {
      e.domEvent?.stopPropagation?.();
      onInfo?.(object);
    },
  });

  if (onUpdateLogistics) {
    items.push({
      key: "updateLogistics",
      label: "Update logistics progress",
      icon: (
        <LocalShippingOutlined style={{ fontSize: 18, color: "#008d8a" }} />
      ),
      onClick: (e) => {
        e.domEvent?.stopPropagation?.();
        onUpdateLogistics(object);
      },
    });
  }

  // 🔸 DIVIDER (if anything below)
  if (canEdit || canShare || AddEnergyComponent || ExtraCreateItems.length) {
    items.push({ type: "divider" });
  }

  // 🔹 CREATE
  if (AddEnergyComponent) {
    items.push({
      key: "addEnergy",
      label: AddEnergyComponent,
      icon: (
        <ElectricBoltOutlined style={{ fontSize: 18, color: "#008d8a" }} />
      ),
    });
  }

  if (ExtraCreateItems.length) {
    items.push(...ExtraCreateItems);
  }

  // 🔸 DIVIDER before edit/share
  if ((canEdit || canShare) && (AddEnergyComponent || ExtraCreateItems.length)) {
    items.push({ type: "divider" });
  }

  // 🔹 EDIT
  if (canEdit) {
    items.push({
      key: "edit",
      label: `Edit ${type}`,
      icon: <EditOutlined style={{ fontSize: 18, color: "#008d8a" }} />,
      onClick: (e) => {
        e.domEvent?.stopPropagation?.();
        onEdit?.(objectId);
      },
    });
  }

  // 🔹 SHARE
  if (canShare && !contentTypeLoading && contentTypeId) {
    items.push({
      key: "share",
      label:
        ShareComponent || (
          <SharePopover
            contentTypeId={contentTypeId}
            objectId={objectId}
            fileName={name}
          />
        ),
    });
  }

  // 🔸 DIVIDER before delete
  if (canDelete) {
    items.push({ type: "divider" });
  }

  // 🔴 DELETE
  if (canDelete) {
    items.push({
      key: "delete",
      label: (
        <span style={{ color: "#e90000" }}>
          Delete {type}
        </span>
      ),
      icon: <DeleteOutlined style={{ fontSize: 18, color: "#e90000" }} />,
      onClick: (e) => {
        e.domEvent?.stopPropagation?.();
        onDelete?.(objectId, type);
      },
    });
  }

  // Rows are sized for touch in index.css through this class.
  return items
    .filter(Boolean)
    .map((item) => (item.type === "divider" ? item : { ...item, className: MENU_ITEM_CLASS }));
};